function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "20",
  viewBox: "0 0 40 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.107 19.474a5.512 5.512 0 00-11.023 0h11.023z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.279 19.474H0c0-.69.036-1.386.107-2.07l2.266.238c-.062.605-.094 1.22-.094 1.832z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.213 13.842L1.058 13.1a19.64 19.64 0 011.895-3.978l1.934 1.204a17.491 17.491 0 00-1.674 3.516zm32.754-.023a17.285 17.285 0 00-1.677-3.509l1.934-1.208a19.376 19.376 0 011.898 3.975l-2.155.742zM7.305 7.273L5.687 5.668a19.737 19.737 0 013.435-2.76l1.22 1.923c-1.1.7-2.119 1.52-3.037 2.442zm24.563-.013a17.488 17.488 0 00-3.037-2.435l1.217-1.928c1.24.785 2.4 1.713 3.438 2.755L31.868 7.26zM13.842 3.135L13.084.986a19.425 19.425 0 014.294-.983l.254 2.266c-1.29.143-2.566.436-3.79.866zm11.486-.006c-1.224-.43-2.5-.72-3.796-.863L21.782 0c1.465.163 2.91.492 4.298.977l-.752 2.152z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.19 19.474h-2.28c0-.612-.032-1.227-.094-1.832l2.266-.238c.072.684.108 1.38.108 2.07z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.584 11.274c0-.453.365-.814.814-.814a.814.814 0 11-.814.814zm0-2.93c0-.453.365-.814.814-.814a.814.814 0 11-.814.814zm0-2.93c0-.453.365-.814.814-.814a.814.814 0 11-.814.814z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.992 16.508a.813.813 0 111.148-1.152.813.813 0 01-1.148 1.152zm-2.074-2.073a.813.813 0 111.152 0 .814.814 0 01-.576.24.814.814 0 01-.576-.24zm-2.07-2.07A.813.813 0 117 11.214a.813.813 0 01-1.152 1.15z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.659 16.509a.813.813 0 111.148-1.153.813.813 0 01-1.148 1.153zm2.07-2.074a.813.813 0 111.152-1.15.813.813 0 01-1.152 1.15zm2.07-2.07a.813.813 0 111.152-1.15.813.813 0 01-1.151 1.15z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.858 13.008a.815.815 0 111.49-.66.815.815 0 01-1.49.66zm-1.192-2.675a.815.815 0 111.075.413.816.816 0 01-1.074-.414zm-1.191-2.676a.815.815 0 011.488-.661.811.811 0 01-.743 1.142.816.816 0 01-.745-.481z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.863 13.422c-.41-.183-.592-.664-.41-1.075a.815.815 0 011.488.661.82.82 0 01-1.078.414zm1.195-2.676a.812.812 0 01-.413-1.074.815.815 0 011.488.66.817.817 0 01-1.075.414zm1.192-2.68a.811.811 0 01-.414-1.07.815.815 0 011.488.66.817.817 0 01-1.075.41z",
  fill: "#000"
})));